var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-button',{staticStyle:{"outline":"none"},attrs:{"color":"danger","type":"relief"},nativeOn:{"click":function($event){return _vm.click($event)}}},[_vm._v(" "+_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }